// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fUs--DatePresetsList--calendarPresetItem{display:flex;justify-content:space-between}.dCt--DatePresetsList--calendarPresetItemTime{color:var(--uikit-color-dimGrey)}.UMa--DatePresetsList--calendarSelect{padding-top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendarPresetItem": "fUs--DatePresetsList--calendarPresetItem",
	"calendarPresetItemTime": "dCt--DatePresetsList--calendarPresetItemTime",
	"calendarSelect": "UMa--DatePresetsList--calendarSelect"
};
module.exports = ___CSS_LOADER_EXPORT___;
